import React, {useState, useCallback} from 'react';
import { CSSTransition } from 'react-transition-group';
import useClickOutside from "../../hooks/useClickOutside";

import styles from './FilterNavigation.module.scss';

import { HAS_CATEGORY_NAVIGATION, HAS_CATEGORY_FILTER } from '../../shared/constants';

export default function FilterNavigation({ config, offersCategories, filterCategory }) {
    const [isOpen, setIsOpen] = useState(false);

    const wrapperRef = useClickOutside(useCallback(() => {
        if(isOpen) {
            setIsOpen(false);
        }
    }, [isOpen]));

    return (
        <div className={styles.filterWrapper}>
            <div className={styles.filtersInnerWrapper} onClick={() => setIsOpen(!isOpen)} ref={wrapperRef}>
                <div className={styles.filterIconWrapper}>
                    <div className={styles.filterIconPart}></div>
                    <div className={styles.filterIconPart}></div>
                    <div className={styles.filterIconPart}></div>
                </div>
                <div className={styles.filterTitle}>
                    <div className={styles.text}>{config.filter}</div>
                </div>
            </div>
            <CSSTransition
                in={isOpen}
                timeout={400}
                classNames="fade-in-slide-down"
                unmountOnExit
            >
                <div className={styles.offerCategoriesWrapper}>
                    {offersCategories && offersCategories.length > 0 && offersCategories.map((category, index) => {
                        return (
                            <div key={index}>
                                {HAS_CATEGORY_NAVIGATION ?
                                    <div key={index} className={`${styles.categoryWrapper} ${styles.shrinkBorder}`}
                                        onClick={() => document.getElementById(category.order).scrollIntoView({behavior: "smooth"})}>
                                        <img src={category.icon} className={styles.categoryFilterImg} alt={category.name}/>
                                    </div>
                                    :
                                    null
                                }
                            </div>
                        )
                    })}
                </div>
            </CSSTransition>
        </div>
    );
};
